<template>
<div id="index">

  <div class="common-seach-wrap">
    <el-form size="small" :inline="true" :model="searchObj">
      <el-form-item label="分类名称">
        <el-input v-model="searchObj.search" placeholder="请输入服务名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="pageChange(1)">查询</el-button>
      </el-form-item>
    </el-form>
  </div>


  <div class="common-level-rail">
    <el-button size="small" type="primary" @click="$refs.addEdit.show()" icon="el-icon-plus" v-auth="'/league/service/add'">添加服务</el-button>
  </div>

  <div class="product-content">
    <div class="table-wrap">
      <el-table size="small" :data="list" >
        <el-table-column prop="name" label="服务名称"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="create_time" label="添加时间"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="$refs.addEdit.show(scope.row)" type="text" size="small" v-auth="'/league/service/edit'">编辑</el-button>
            <el-button @click="deleteTap(scope.row)" type="text" size="small" v-auth="'/league/service/delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>

  <div class="pagination">
    <el-pagination
      @current-change="pageChange"
      background
      :current-page="searchObj.page"
      :page-size="searchObj.list_rows"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>


  <AddEdit ref="addEdit" @refresh="getData"></AddEdit>


</div>
</template>

<script>
import AddEdit from './addEdit.vue';
import LeagueApi from '@/api/league'
export default {
  components:{AddEdit},
  data() {
    return {
      searchObj:{
        page:1,
        list_rows:10,
        search:'',
      },
      list: [],
      total:0,
    }
  },
  created(){
    this.getData()
  },
  methods:{

    getData(){
      LeagueApi.serviceIndex(this.searchObj).then(result=>{
        let list=result.data.service
        this.list=list.data
        this.total=list.total
      })
    },

    // 删除
    deleteTap(e){
      this.$confirm('确认删除当前服务吗？','提示',{type: 'warning'}).then(() => {
        LeagueApi.serviceDelete({service_id:e.service_id}).then(result=>{
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getData()
        })
      })
    },

    // 分页
    pageChange(e){
      this.searchObj.page=e
      this.getData()
    },

  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/league/service/index.vue